export const AddressData = () => {
  return <h1>Address data</h1>;
};
